import React from 'react';
import PropTypes from 'prop-types';
import { IconThumbsDown, IconThumbsUp } from '@americanexpress/dls-icons';
import {
  Card,
  CardContent,
  CardLayout,
  Heading,
} from '@americanexpress/dls-react';

const formatLocalDateTime = (timestamp) => {
  if (!timestamp) {
    return null;
  }

  const parsedDate = new Date(timestamp);
  if (Number.isNaN(parsedDate.getTime())) {
    return null;
  }

  return parsedDate.toLocaleString();
};

const HotelSentimentCard = ({
  pros = [],
  cons = [],
  updatedAt,
}) => {
  const hasSentimentPoints = pros.length > 0 || cons.length > 0;
  const localUpdatedAt = formatLocalDateTime(updatedAt);

  if (!hasSentimentPoints) {
    return null;
  }

  return (
    <div className="row margin-2-t">
      <div className="col">
        <Card data-dls-mode="dark">
          <CardLayout>
            <CardContent className="pad-1">
              <Heading level={3} variant="sans-medium-bold" className="pad-b">
                Guest sentiment
              </Heading>
              <div className="row margin-1-t">
                <div className="col-xs-12">
                  <div className="flex flex-align-items-center margin-1-b">
                    <div className="flex-item-shrink">
                      <IconThumbsUp color="white" size="lg" title="Positive sentiment" />
                    </div>
                    <p className="body-bold margin-0 margin-1-l text-align-left flex-item-grow">
                      {pros.map((point, index) => (
                        <span key={point}>
                          {index > 0 ? ' \u2022 ' : ''}
                          {point}
                        </span>
                      ))}
                    </p>
                  </div>
                </div>
                <div className="col-xs-12">
                  <div className="flex flex-align-items-center margin-1-b">
                    <div className="flex-item-shrink">
                      <IconThumbsDown color="white" size="lg" title="Negative sentiment" />
                    </div>
                    <p className="body-bold margin-0 margin-1-l text-align-left flex-item-grow">
                      {cons.map((point, index) => (
                        <span key={point}>
                          {index > 0 ? ' \u2022 ' : ''}
                          {point}
                        </span>
                      ))}
                    </p>
                  </div>
                </div>
              </div>
              {localUpdatedAt ? (
                <p className="body-2 margin-2-t margin-0-b">
                  Sentiment updated:
                  {' '}
                  {localUpdatedAt}
                </p>
              ) : null}
            </CardContent>
          </CardLayout>
        </Card>
      </div>
    </div>
  );
};

HotelSentimentCard.propTypes = {
  pros: PropTypes.arrayOf(PropTypes.string),
  cons: PropTypes.arrayOf(PropTypes.string),
  updatedAt: PropTypes.string,
};

export default HotelSentimentCard;
